module.exports = __webpack_public_path__ + "img/edit_check.a3ff42e9.svg";